import type { ReactNode } from 'react';

export interface NavItem {
  label: string;
  to: string;
  icon?: ReactNode;
  exact?: boolean;
}

export interface NavSection {
  label: string;
  items: NavItem[];
}

export const NAV_SECTIONS: NavSection[] = [
  {
    label: 'Genel Bakış',
    items: [
      {
        label: 'Yönetici Paneli',
        to: '/',
        icon: '📊',
        exact: true,
      },
      {
        label: 'Günlük Gelir',
        to: '/analytics/daily-income',
        icon: '💹',
      },
      {
        label: 'En Çok Satanlar',
        to: '/analytics/top-sellers',
        icon: '🥇',
      },
    ],
  },
  {
    label: 'Menü ve Kampanyalar',
    items: [
      {
        label: 'Ürünler',
        to: '/catalog/products',
        icon: '🍕',
      },
      {
        label: 'Kategoriler',
        to: '/catalog/categories',
        icon: '🗂️',
      },
      {
        label: 'Opsiyonlar',
        to: '/catalog/options',
        icon: '⚙️',
      },
      {
        label: 'Kuponlar',
        to: '/marketing/coupons',
        icon: '🎟️',
      },
      {
        label: 'Dilim Milestones',
        to: '/marketing/dilim-milestones',
        icon: '🎁',
      },
    ],
  },
  {
    label: 'Operasyon',
    items: [
      {
        label: 'Push Bildirimleri',
        to: '/messaging/push',
        icon: '📣',
      },
      {
        label: 'Siparişler',
        to: '/operations/orders',
        icon: '🧾',
      },
      {
        label: 'Restoran Ayarları',
        to: '/operations/restaurants',
        icon: '🏬',
      },
      {
        label: 'Vergi Ayarları',
        to: '/operations/tax-settings',
        icon: '💰',
      },
      {
        label: 'Ödeme Ayarları',
        to: '/operations/payment-settings',
        icon: '💳',
      },
      {
        label: 'Pazar Yeri Köprüsü',
        to: '/operations/marketplace-bridge',
        icon: '🔌',
      },
      {
        label: 'Personel',
        to: '/people/staff',
        icon: '🧑‍🍳',
      },
      {
        label: 'Müşteriler',
        to: '/people/users',
        icon: '👤',
      },
      {
        label: 'Kuryeler',
        to: '/people/drivers',
        icon: '🚗',
      },
    ],
  },
  {
    label: 'Muhasebe',
    items: [
      {
        label: 'Muhasebe Özeti',
        to: '/muhasebe/ozet',
        icon: '\u{1F4CA}',
      },
      {
        label: 'Giderler',
        to: '/muhasebe/giderler',
        icon: '📉',
      },
      {
        label: 'Gelirler',
        to: '/muhasebe/gelirler',
        icon: '💵',
      },
    ],
  },
  {
    label: 'Geri Bildirim',
    items: [
      {
        label: 'Müşteri Yorumları',
        to: '/feedback/comments',
        icon: '\u{1F4AC}',
      },
    ],
  },
];
